import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as ticketAction from './../../../../actions/ticketAction';
import TicketAssignConfigs from './TicketAssignConfigs';

const mapStateToProps = state => {
    return {
        ticketState: state.ticketReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTicketAssignConfigList: (params) => dispatch(ticketAction.getTicketAssignConfigList(params)),
        deleteTicketAssignConfig: (ticketAssignConfig, refreshParams) => dispatch(ticketAction.deleteTicketAssignConfig(ticketAssignConfig, refreshParams)),

    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TicketAssignConfigs));
